import React from 'react';
import { oembed } from '@loomhq/loom-embed';
import { useState, useEffect } from 'react';
import {
  Typography,
  Container,
  Grid,
  Tooltip,
  Card,
  CardHeader,
  CardMedia,
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paper,
} from '@mui/material';
import {
  ViewHeadlineOutlined,
  GridViewOutlined,
  ExpandMore,
} from '@mui/icons-material';
import { OEmbedInterface } from '@loomhq/loom-embed/dist/.types/oembed';

const looms = [
  'https://www.loom.com/share/977b252bc753485f892c03f011713b9d',
  'https://www.loom.com/share/3b420310d106407da7ffca53413b262a',
  'https://www.loom.com/share/15a7ca94a6f346a1b1c080f12a28624d',
  'https://www.loom.com/share/e5bbddb8188d4c56af7b6ee72a31cb00',
  'https://www.loom.com/share/6184b328255a43acb7f3ac02180ae628',
  'https://www.loom.com/share/8adcddcfad004f1799490be5da297f2b',
  'https://www.loom.com/share/00b63524743b4ca69679b65540cd8069',
  'https://www.loom.com/share/39531299ed984bedaeaf65d292d13afe',
  'https://www.loom.com/share/6b6eb775f3fe4ecabc8f7813b8b7a0ae',
  'https://www.loom.com/share/ac9025f3c4ad4aeca0036c417902d794',
  'https://www.loom.com/share/dbe47d2b589e415084bb5168099d56c3',
];

export const LoomPage = ({ search }: { search: string }) => {
  const [view, setView] = useState<'list' | 'grid'>('list');

  return (
    <Paper elevation={3}>
      <Container sx={{ pb: 5 }}>
        <Grid
          container
          spacing={3}
          alignItems={'stretch'}
          alignContent={'stretch'}
        >
          <Grid item xs={12}>
            <ToggleButtonGroup
              value={view}
              exclusive
              onChange={(event: any, value: any) => setView(value)}
            >
              <ToggleButton value="list">
                <ViewHeadlineOutlined />
              </ToggleButton>
              <ToggleButton value="grid">
                <GridViewOutlined />
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          {view === 'list' ? (
            <Grid item xs={12}>
              <Stack sx={{ width: '100%' }}>
                {looms.map((loom, index) => (
                  <LoomAccordion key={index} loom={loom} search={search} />
                ))}
              </Stack>
            </Grid>
          ) : (
            looms.map((loom, index) => (
              <LoomCard key={index} loom={loom} search={search} />
            ))
          )}
        </Grid>
      </Container>
    </Paper>
  );
};

export const LoomCard = ({
  loom,
  search,
}: {
  loom: string;
  search: string;
}) => {
  const [embed, setEmbed] = useState<OEmbedInterface>();

  const getVideo = async () => {
    const result = await oembed(loom);
    setEmbed(result);
  };

  useEffect(() => {
    getVideo();
    // eslint-disable-next-line
  }, []);

  return (
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        display: embed?.title?.toLowerCase()?.includes(search.toLowerCase())
          ? 'block'
          : 'none',
      }}
    >
      <LoomEmbedCard embed={embed} />
    </Grid>
  );
};

export const LoomAccordion = ({
  loom,
  search,
}: {
  loom: string;
  search: string;
}) => {
  const [embed, setEmbed] = useState<OEmbedInterface>();

  const getVideo = async () => {
    const result = await oembed(loom);
    setEmbed(result);
  };

  useEffect(() => {
    getVideo();
    // eslint-disable-next-line
  }, []);
  const [isClickExpanded, setIsClickExpanded] = useState<boolean>(false);
  const onClick = () => {
    setIsClickExpanded(!isClickExpanded);
  };
  return (
    <Accordion
      expanded={isClickExpanded}
      onClick={onClick}
      sx={{
        display: embed?.title?.toLowerCase()?.includes(search.toLowerCase())
          ? 'block'
          : 'none',
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography color="primary" className="font-medium py-2">
          {embed?.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <LoomEmbedCard embed={embed} title={false} />
      </AccordionDetails>
    </Accordion>
  );
};

export const LoomEmbedCard = ({
  embed,
  title = true,
}: {
  embed?: OEmbedInterface;
  title?: boolean;
}) => {
  return (
    <Card>
      {title && (
        <Tooltip
          title={embed?.title || ''}
          followCursor={true}
          placement="top-start"
        >
          <CardHeader
            title={embed?.title}
            titleTypographyProps={{
              sx: {
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                width: '85%',
              },
            }}
          />
        </Tooltip>
      )}
      <CardMedia sx={{ mx: 'auto' }}>
        <div
          style={{ textAlign: 'center' }}
          dangerouslySetInnerHTML={{ __html: embed?.html || '' }}
        ></div>
      </CardMedia>
    </Card>
  );
};
